/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteControllerResponse } from '../model';
// @ts-ignore
import { GetControllerResponse } from '../model';
// @ts-ignore
import { GetControllersResponse } from '../model';
// @ts-ignore
import { PostControllerRequest } from '../model';
// @ts-ignore
import { PostControllersResponse } from '../model';
// @ts-ignore
import { PutControllerRequest } from '../model';
// @ts-ignore
import { PutControllersResponse } from '../model';
/**
 * ControllersApi - axios parameter creator
 * @export
 */
export const ControllersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostControllerRequest} postControllerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewController: async (postControllerRequest: PostControllerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postControllerRequest' is not null or undefined
            assertParamExists('addNewController', 'postControllerRequest', postControllerRequest)
            const localVarPath = `/api/controllers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postControllerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteController: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteController', 'id', id)
            const localVarPath = `/api/controllers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutControllerRequest} putControllerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editController: async (id: string, putControllerRequest: PutControllerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editController', 'id', id)
            // verify required parameter 'putControllerRequest' is not null or undefined
            assertParamExists('editController', 'putControllerRequest', putControllerRequest)
            const localVarPath = `/api/controllers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putControllerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getController: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getController', 'id', id)
            const localVarPath = `/api/controllers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControllers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/controllers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControllersApi - functional programming interface
 * @export
 */
export const ControllersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControllersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostControllerRequest} postControllerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewController(postControllerRequest: PostControllerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostControllersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewController(postControllerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteController(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteControllerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteController(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutControllerRequest} putControllerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editController(id: string, putControllerRequest: PutControllerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutControllersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editController(id, putControllerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getController(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetControllerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getController(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControllers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetControllersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControllers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ControllersApi - factory interface
 * @export
 */
export const ControllersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControllersApiFp(configuration)
    return {
        /**
         * 
         * @param {PostControllerRequest} postControllerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewController(postControllerRequest: PostControllerRequest, options?: any): AxiosPromise<PostControllersResponse> {
            return localVarFp.addNewController(postControllerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteController(id: string, options?: any): AxiosPromise<DeleteControllerResponse> {
            return localVarFp.deleteController(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutControllerRequest} putControllerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editController(id: string, putControllerRequest: PutControllerRequest, options?: any): AxiosPromise<PutControllersResponse> {
            return localVarFp.editController(id, putControllerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getController(id: string, options?: any): AxiosPromise<GetControllerResponse> {
            return localVarFp.getController(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControllers(options?: any): AxiosPromise<GetControllersResponse> {
            return localVarFp.getControllers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNewController operation in ControllersApi.
 * @export
 * @interface ControllersApiAddNewControllerRequest
 */
export interface ControllersApiAddNewControllerRequest {
    /**
     * 
     * @type {PostControllerRequest}
     * @memberof ControllersApiAddNewController
     */
    readonly postControllerRequest: PostControllerRequest
}

/**
 * Request parameters for deleteController operation in ControllersApi.
 * @export
 * @interface ControllersApiDeleteControllerRequest
 */
export interface ControllersApiDeleteControllerRequest {
    /**
     * 
     * @type {string}
     * @memberof ControllersApiDeleteController
     */
    readonly id: string
}

/**
 * Request parameters for editController operation in ControllersApi.
 * @export
 * @interface ControllersApiEditControllerRequest
 */
export interface ControllersApiEditControllerRequest {
    /**
     * 
     * @type {string}
     * @memberof ControllersApiEditController
     */
    readonly id: string

    /**
     * 
     * @type {PutControllerRequest}
     * @memberof ControllersApiEditController
     */
    readonly putControllerRequest: PutControllerRequest
}

/**
 * Request parameters for getController operation in ControllersApi.
 * @export
 * @interface ControllersApiGetControllerRequest
 */
export interface ControllersApiGetControllerRequest {
    /**
     * 
     * @type {string}
     * @memberof ControllersApiGetController
     */
    readonly id: string
}

/**
 * ControllersApi - object-oriented interface
 * @export
 * @class ControllersApi
 * @extends {BaseAPI}
 */
export class ControllersApi extends BaseAPI {
    /**
     * 
     * @param {ControllersApiAddNewControllerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControllersApi
     */
    public addNewController(requestParameters: ControllersApiAddNewControllerRequest, options?: AxiosRequestConfig) {
        return ControllersApiFp(this.configuration).addNewController(requestParameters.postControllerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControllersApiDeleteControllerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControllersApi
     */
    public deleteController(requestParameters: ControllersApiDeleteControllerRequest, options?: AxiosRequestConfig) {
        return ControllersApiFp(this.configuration).deleteController(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControllersApiEditControllerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControllersApi
     */
    public editController(requestParameters: ControllersApiEditControllerRequest, options?: AxiosRequestConfig) {
        return ControllersApiFp(this.configuration).editController(requestParameters.id, requestParameters.putControllerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControllersApiGetControllerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControllersApi
     */
    public getController(requestParameters: ControllersApiGetControllerRequest, options?: AxiosRequestConfig) {
        return ControllersApiFp(this.configuration).getController(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControllersApi
     */
    public getControllers(options?: AxiosRequestConfig) {
        return ControllersApiFp(this.configuration).getControllers(options).then((request) => request(this.axios, this.basePath));
    }
}
